import { Component, ViewEncapsulation, ChangeDetectorRef, Inject, PLATFORM_ID, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthService, NbLoginComponent } from '@nebular/auth';
import { isPlatformBrowser } from '@angular/common';
import { NB_AUTH_OPTIONS } from '@nebular/auth';
import { APP_EMAIL_SUFFIX } from '../../utils/company-details';

@Component({
  selector: 'ngx-custom-login',
  templateUrl: './custom-login.component.html',
  styleUrls: ['./custom-login.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomLoginComponent extends NbLoginComponent implements OnInit, OnDestroy {

  // Your custom UI state
  showPassword = false;
  isDark = false;

  images = [
    'assets/images/1.webp',
    'assets/images/6.webp',
    'assets/images/2.webp',
    'assets/images/3.webp',
    'assets/images/4.webp',
    'assets/images/5.webp',
  ];

  activeIndex = 0;
  private slideInterval: any;

  constructor(
    service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) options: {},
    cd: ChangeDetectorRef,
    router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    super(service, options, cd, router);
  }


  // -------------------
  // LIFECYCLE
  // -------------------
  ngOnInit() {
    // super.ngOnInit();
    this.startSlideshow();
  }

  ngOnDestroy() {
    // super.ngOnDestroy();
    clearInterval(this.slideInterval);
  }

  // -------------------
  // CUSTOM FEATURES
  // -------------------
  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleTheme() {
    this.isDark = !this.isDark;
  }


  emailUsername = '';
  domain = APP_EMAIL_SUFFIX;
  // domain = '';


  startSlideshow() {
    if (!isPlatformBrowser(this.platformId)) return;

    this.slideInterval = setInterval(() => {
      this.activeIndex = (this.activeIndex + 1) % this.images.length;
    }, 3000);
  }

  // -------------------
  // LOGIN
  // -------------------
  override login(): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    // ✅ BUILD FULL EMAIL HERE
    this.user.email = `${this.emailUsername}${this.domain}`;

    // Safety: handle a missing username
    if (!this.emailUsername) {
      this.errors = ['Please enter your email username'];
      this.submitted = false;
      return;
    }

    // ✅ now proceed with Nebular auth
    super.login();
  }

}
